import { render } from "./mediaLib.vue?vue&type=template&id=014064cc&scoped=true"
import script from "./mediaLib.vue?vue&type=script&lang=js"
export * from "./mediaLib.vue?vue&type=script&lang=js"

import "./mediaLib.vue?vue&type=style&index=0&id=014064cc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3423045755/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014064cc"]])

export default __exports__